export default __webpack_public_path__ + "static/media/alert.d1d9f6c9.jpg";